import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import { throttle } from 'lodash';
export var useScrollContainer = function useScrollContainer() {
  var ref = useRef(null);

  var _useState = useState({
    atTop: true,
    atBottom: true,
    scroll: 0,
    height: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var throttledHandler = useMemo(function () {
    return throttle(function (scrollHeight, scrollTop, containerHeight) {
      setState({
        atTop: scrollHeight <= containerHeight || scrollTop <= 10,
        atBottom: scrollHeight <= containerHeight || scrollTop >= scrollHeight - containerHeight - 10,
        scroll: scrollTop,
        height: containerHeight
      });
    }, 250);
  }, []);
  var resizeObserver = useMemo(function () {
    return new ResizeObserver(function (entries) {
      if (entries.length > 0) {
        var div = entries[0].target;
        throttledHandler(div.scrollHeight, div.scrollTop, div.offsetHeight);
      }
    });
  }, [throttledHandler]);
  var onScroll = useCallback(function (event) {
    var e = event.currentTarget;
    throttledHandler(e.scrollHeight, e.scrollTop, e.offsetHeight);
  }, [throttledHandler]);
  useEffect(function () {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      var div = ref.current;
      throttledHandler(div.scrollHeight, div.scrollTop, div.offsetHeight);
    }
  }, [throttledHandler]);
  useEffect(function () {
    var containerDiv = ref.current;
    if (containerDiv) resizeObserver.observe(containerDiv);
    return function () {
      if (containerDiv) resizeObserver.unobserve(containerDiv);
    };
  }, [resizeObserver]);
  return _objectSpread({
    onScroll: onScroll,
    ref: ref
  }, state);
};